import React, { Component } from 'react'
import Question from './Question';
import GreenButtonHeader from '../misc/GreenButtonHeader'
import QuizBulletList from './QuizBulletList'
import axios from 'axios';
import Forward from '../../assets/imgs/forward.png';

export class QuestionsList extends Component {

    state = {
        categories: [],
        quizStep: 0,
        width: window.innerWidth,
        payload: {
            answers: []
        }
    };

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
        axios.get(`http://web.wholechildapp.com/api/quizzes/` + this.props.api_link).then(res => {
            const answers = [
                { id: 4, value: 'Mastered', selected: false },
                { id: 3, value: 'With Guidance', selected: false },
                { id: 2, value: 'Emerging', selected: false },
                { id: 1, value: 'Not Observed', selected: false },
            ];
            const categories = res.data.quiz.categories.map(category => {
                category.questions.forEach(question => {
                    question.answers = [...answers];
                });
                return category;
            });

            this.setState({ categories });
        })
    }

    handleWindowSizeChange = () => {
        this.setState({
            width: window.innerWidth
        });
    };

    goToHomepage = () => {
        window.location.href = "http://web.wholechildapp.com/"
    }

    handleChangeForced = (input, e) => {
        this.setState({ [input]: e });
    };

    quizNextStep = () => {
        const { categories, quizStep } = this.state;
        var cognitive = document.querySelector('.error-tooltip');
        if (this.state.payload.answers.length !== this.state.categories[quizStep].questions.length) {
            window.scrollTo(0, 0);
            cognitive.style.display = "block";
        }
        else {
            cognitive.style.display = "none";
            if (quizStep === 5) {
                var a = {
                    category_id: categories[quizStep].id,
                    answers: this.state.payload.answers
                }
                this.props.handlePayLoad(a)
                this.props.handleChangeForced('showEmailPopup', true);
            } else {
                this.setState({
                    quizStep: quizStep + 1
                })
                var e = {
                    category_id: categories[quizStep].id,
                    answers: this.state.payload.answers
                }
                this.props.handlePayLoad(e)
                this.state.payload.answers = []
                document.getElementById('backButton').style.display = 'block';
                window.scrollTo(0, 0)
            }
        }
    }

    quizPrevStep = () => {
        const { quizStep } = this.state;
        this.setState({
            quizStep: quizStep - 1
        })
        if (quizStep < 2)
            document.getElementById('backButton').style.display = 'none';
    }

    createQuestion = label => (
        <Question
            questionText={label}
        />
    )

    createQuestions = step => {
        const { categories, quizStep, payload } = this.state;
        if (categories[step]) {
            //add active state
            if (this.props.responses[quizStep]) {
                //console.log(this.props.responses[quizStep])
                payload.answers = this.props.responses[quizStep].answers;
                return categories[step].questions.map((question, index) =>
                    <Question key={question.id}
                        question={question}
                        selected={payload.answers[index].answer}
                        update={this.addToPayload}
                        color={categories[step].color} />
                )
            }
            else {
                return categories[step].questions.map((question, index) =>
                    <Question key={question.id}
                        question={question}
                        update={this.addToPayload}
                        color={categories[step].color} />
                )
            }
        } else {
            return [];
        }
    };

    addToPayload = data => {
        const { payload } = this.state;
        if (payload.answers.length === 0) {
            payload.answers.push(data);
        }
        else {
            for (let i = 0; i < payload.answers.length; i++) {
                if (payload.answers[i].question_id === data.question_id) {
                    if (payload.answers[i].answer !== data.answer) {
                        //console.log(`s a modificat in ${payload.answers[i].question_id} din ${payload.answers[i].answer} in ${data.answer}`)
                        payload.answers[i].answer = data.answer
                        break;
                    }
                    else {
                        break;
                    }
                }
                else {
                    if (i === payload.answers.length - 1) {
                        //console.log(`s a creat ${data.question_id} cu ${data.answer}`)
                        payload.answers.push(data)
                    }
                }
            }
        }
    };

    showText = () => {
        if (this.state.width > 800) {
            // return <p className="chooseAgeText"><span className="blue-color">WholeChild®</span> 6 Areas of Development Test</p>
        }
    }

    changeCss() {
        var bodyElement = document.querySelector(".noDisplay");
        this.scrollY > 300 ? bodyElement.classList.add('scrollyPencil') : bodyElement.classList.remove('scrollyPencil')
    }

    componentDidMount() {
        window.addEventListener('scroll', this.changeCss)
    }


    render() {
        return (
            <div>
                {/* <div id="saramana" className="header-chooseage"></div> */}
                <div className="onlyResultMobile">
                    <img className="headerLogo" src={require("../../assets/imgs/logo-blue.png")} alt="logo" />
                </div>
                <div className="header-chooseage">
                    <div className="bar">
                        <img className="headerLogo" src={require("../../assets/imgs/logo-blue.png")} alt="logo" />
                        <p className="headerText">6 Areas of Development Test</p>
                        <GreenButtonHeader nextStep={this.goToHomepage} name="GO TO HOMEPAGE" />
                    </div>
                    {this.showText()}
                    {/* <p className="chooseAgeText"><span className="blue-color">WholeChild®</span> 2019 Personality Quiz</p> */}
                    <QuizBulletList
                        step={this.state.quizStep}
                        api_link={this.props.api_link}
                    />
                </div>
                <div className="header-chooseage noDisplay">
                    <div className="onlyResultMobile">
                        <img className="headerLogo" src={require("../../assets/imgs/logo-blue.png")} alt="logo" />
                    </div>
                    <div className="bar">

                        <img className="headerLogo" src={require("../../assets/imgs/logo-blue.png")} alt="logo" />
                        <p className="headerText">6 Areas of Development Test</p>
                        <GreenButtonHeader nextStep={this.goToHomepage} name="GO TO HOMEPAGE" />
                    </div>
                    {this.showText()}
                    {/* <p className="chooseAgeText"><span className="blue-color">WholeChild®</span> 2019 Personality Quiz</p> */}
                    <QuizBulletList
                        step={this.state.quizStep}
                        api_link={this.props.api_link}
                    />
                </div>
                <div>
                    {this.createQuestions(this.state.quizStep)}
                    <div className="questionsFooter">
                        <span id="backButton" onClick={this.quizPrevStep} className="backButton">&lt;&lt;Back</span>
                        <button onClick={this.quizNextStep} className="forwardButton">
                            <img src={Forward} alt="forward-button" />
                        </button>
                    </div>
                </div>
            </div>

        )
    }
}

export default QuestionsList
